import { useState, useEffect } from "react";
import { MessageCircle, Mail, Copy, Check, Link as LinkIcon, Eye } from "lucide-react";
import Modal from "../components/Modal";
import Field, { selectStyle } from "../components/Field";
import { encodePesquisaToken, pesquisaUrl, whatsappPesquisa, emailPesquisa } from "../lib/pesquisaLink";

export default function SendPesquisaLink({ open, onClose, clients = [], partners = [], userId }) {
  const [audience, setAudience] = useState("cliente");
  const [recipientId, setRecipientId] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => { if (open) { setAudience("cliente"); setRecipientId(""); setCopied(false); } }, [open]);

  const list = audience === "cliente" ? clients : partners;
  const recipient = list.find((x) => x.id === recipientId) || null;
  const nome = audience === "cliente" ? recipient?.company : (recipient?.nomeFantasia || recipient?.name);
  const phone = recipient?.phone || recipient?.whatsapp || "";

  const token = encodePesquisaToken({
    a: audience, u: userId || null,
    id: audience === "cliente" ? recipient?.id || null : null,
    p: audience === "fornecedor" ? recipient?.id || null : null,
    n: nome || null,
  });
  const url = pesquisaUrl(token);

  const copiar = async () => { try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 2000); } catch { /* ignora */ } };
  const modeBtn = (on) => ({ flex: 1, padding: "9px", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, textAlign: "center", border: on ? "1.5px solid #7c3aed" : "1px solid #e2e8f0", background: on ? "#f5f3ff" : "#fff", color: on ? "#6d28d9" : "#475569" });
  const send = { display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "11px", borderRadius: 10, border: "none", fontSize: 14, fontWeight: 600, cursor: "pointer", color: "#fff", flex: 1, textDecoration: "none" };

  return (
    <Modal open={open} onClose={onClose} title="Enviar pesquisa de satisfação" w={520}>
      <div style={{ display: "flex", gap: 6, marginBottom: 14 }}>
        <div onClick={() => { setAudience("cliente"); setRecipientId(""); }} style={modeBtn(audience === "cliente")}>Cliente</div>
        <div onClick={() => { setAudience("fornecedor"); setRecipientId(""); }} style={modeBtn(audience === "fornecedor")}>Fornecedor / Parceiro</div>
      </div>

      <Field label={`Destinatário (opcional)`}>
        <select style={selectStyle} value={recipientId} onChange={(e) => setRecipientId(e.target.value)}>
          <option value="">— Sem vínculo / genérico —</option>
          {list.map((x) => <option key={x.id} value={x.id}>{audience === "cliente" ? x.company : x.name}</option>)}
        </select>
      </Field>

      <div style={{ borderRadius: 10, border: "1px dashed #cbd5e1", background: "#f8fafc", padding: 12, fontSize: 12, color: "#475569", lineHeight: 1.5 }}>
        O {audience === "cliente" ? "cliente" : "fornecedor"} responderá: <strong>nota NPS (0–10)</strong> + as perguntas configuradas{audience === "fornecedor" ? " + quais clientes atende" : ""}. As perguntas são editáveis na aba Satisfação.
        <button onClick={() => window.open(`${url}&preview=1`, "_blank")} style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 10, padding: "7px 12px", borderRadius: 7, border: "1px solid #7c3aed", background: "#fff", color: "#6d28d9", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
          <Eye size={13} /> Abrir prévia
        </button>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 12px", borderRadius: 10, background: "#f8fafc", border: "1px solid #e2e8f0", marginTop: 14 }}>
        <LinkIcon size={14} color="#94a3b8" style={{ flexShrink: 0 }} />
        <span style={{ fontSize: 12, color: "#475569", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>{url}</span>
        <button onClick={copiar} style={{ display: "flex", alignItems: "center", gap: 4, padding: "5px 10px", borderRadius: 6, border: "1px solid #e2e8f0", background: "#fff", color: copied ? "#059669" : "#475569", fontSize: 11, fontWeight: 600, cursor: "pointer", flexShrink: 0 }}>
          {copied ? <><Check size={12} /> Copiado</> : <><Copy size={12} /> Copiar</>}
        </button>
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
        <a href={whatsappPesquisa(phone, token, audience, nome)} target="_blank" rel="noreferrer" style={{ ...send, background: "#25D366" }}><MessageCircle size={16} /> WhatsApp</a>
        <a href={emailPesquisa(token, audience, nome)} style={{ ...send, background: "#516BCC" }}><Mail size={16} /> E-mail</a>
      </div>
    </Modal>
  );
}
